import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private _getCustomerNoUrl = `${environment.api}/Contact/getContactNumber`;
  private _saveContactUrl = `${environment.api}/Contact/contactSave`;
  private _getContactListUrl = `${environment.api}/Contact/getContactList`;

  private _getContactListUrl1 = `${environment.api}/Contact/getContactList1`;

  private _deleteContactUrl = `${environment.api}/Contact/contactDelete`;
  private _contactStatusUrl = `${environment.api}/Contact/contactActiveById`;
  private _getContactByidUrl = `${environment.api}/Contact/getContactById`;
  private _getContactAddressidUrl = `${environment.api}/Contact/getContactAddressById`;
  private _updateContactUrl = `${environment.api}/Contact/contactUpdate`;
  private _getContactaddressByidUrl = `${environment.api}/Contact/getContactEmailsById`;
  

  private _getAssignContactListByidUrl = `${environment.api}/Contact/getAssignContactListByid`;

  ///code by dk 
  private _saveImportContactUrl = `${environment.api}/Contact/saveImportContact`;

   //added by deepak on 31march2022
  private _exportCustomerUrl = `${environment.api}/Contact/exportCustomerCsv`;

  constructor(private http: HttpClient) { }

  getContactNumber(data)
  {
    return this.http.post<any>(this._getCustomerNoUrl,data);
  }

  getAssignContactListByid(data)
  {
    return this.http.post<any>(this._getAssignContactListByidUrl,data);
  }


  saveContact(data)
  {
     return this.http.post<any>(this._saveContactUrl,data);
  }

  getContactList(data)
  {
     return this.http.post<any>(this._getContactListUrl,data);
  }

  getContactList1(data)
  {
     return this.http.post<any>(this._getContactListUrl1,data);
  }




  deleteContact(data)
  {
     return this.http.post<any>(this._deleteContactUrl,data);
  }
  activeContact(data)
  {
     return this.http.post<any>(this._contactStatusUrl,data);
  }

  getContactByid(data)
  {
     return this.http.post<any>(this._getContactByidUrl,data);
  }

  getContactEmailsByid(data)
  {
     return this.http.post<any>(this._getContactaddressByidUrl,data);
  }

  

  getContactaddressByid(data)
  {
     return this.http.post<any>(this._getContactAddressidUrl,data);
  }

  updateContact(data)
  {
     return this.http.post<any>(this._updateContactUrl,data);
  }

  saveImportContact(data)
  {
     return this.http.post<any>(this._saveImportContactUrl,data);
  }

  //created by deepak 31/march/2022
  exportCustomerCsv(data)
  {
    return this.http.post<any>(this._exportCustomerUrl,data);
  }
 
  

}
